import Support from 'components/Support/Support'

export default Support
